<template>
  <div>
    <a
      target="_self"
      @click="toggleDialog()"
      class="
        icons
        headerMessages
        thin
        gc-shared-opentowork-navicon__desktopicon
      "
      data-tooltip-text="Open to Work"
    >
      <span :class="className" class="menu-icon opentoworkStatusIcon"></span>
    </a>

    <div
      class="gc-shared-opentowork-navicon__mobileicon"
      @click="toggleOpenToWork"
    >
      <a class="icons headerMessages thin">
        <span :class="className" class="menu-icon opentoworkStatusIcon"></span>
        Open to Work
        <span class="redDotInline" v-if="!opentoworkTooltipSeen">New</span>
      </a>

      <gc-opentowork-switch
        class="gc-shared-opentowork-navicon__mobileswitch"
      ></gc-opentowork-switch>
    </div>
  </div>
</template>



<script>
import gcOpentoworkSwitch from "./gcOpentoworkSwitch.vue";

export default {
  name: "gcOpentoworkNavicon",
  components: {
    gcOpentoworkSwitch,
  },
  methods: {
    toggleDialog() {
      Grabcad.opentoworkStore.commit("toggleOpentoworkDialog");
    },
    toggleOpenToWork() {
      Grabcad.opentoworkStore.dispatch("toggleOpentoworkStatus");
    },
  },
  computed: {
    className() {
      return this.opentoworkStatus
        ? "openToWorkEnabledIcon"
        : "openToWorkDisabledIcon";
    },
    opentoworkTooltipSeen() {
      return Grabcad.opentoworkStore.state.opentoworkTooltipSeen;
    },
    opentoworkStatus() {
      return Grabcad.opentoworkStore.state.opentoworkStatus;
    },
  },
};
</script>
